<template lang="pug">
  .table-responsive
    table#tbOtrasAsignaciones.table.is-striped.is-fullwidth
      thead
        tr
          th #
          th Descripción
          th Fecha Reg.
          th Recibe
          th Ubicación
          th Estatus
      tbody
        tr(v-for="(data, index) in otrasAsignaciones" :key="data.id")
          td 
            a.button.is-black.is-rounded.is-small {{ index + 1 }} 
          td(v-if="data.serie !==''")
            span.tag.is-dark
              | {{ data.descripcion }}
            a.button.is-light.is-rounded.is-small(@click="verHistoria(data.id)")
              i.fas.fa-history
            br
            small
              b Serie: {{ data.serie }}
          td(v-else)
            span.tag.is-dark
              | {{ data.descripcion }}
            a.button.is-light.is-rounded.is-small(@click="verHistoria(data.id)")
              i.fas.fa-history
          td 
            span.tag.is-light
              | {{ data.fechaReg }}
          td
            span.tag.is-black {{ data.recibe }}
            | &nbsp
          td
            span.tag.is-black(@click="cambiarUbicacion(data)")
              | {{ ubicacion_ofi }}
            span.tag.is-light
              | {{ oficinaStr }}
          td(v-html="getClassEstado(data)")
</template>

<script>
  import { mapState } from 'vuex'
  import InventarioServices from '../../services/inventario/inventario'
  import moment from 'moment'

  export default {
    name: 'TbOtrasAsignaciones',
    props: {
      otrasAsignaciones: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        configModal: {},
        modalStatus: false,
        itemCambiar: {},
      }
    },
    methods: {
      getClassEstado(asig)  {
        switch (asig.estado) {
          case 7:
            return `<span class="tag is-primary">En Pruebas</span>`
          case 8:
            return `<span class="tag is-ligth">Instalado</span>`
          case 9:
            return `<span class="tag is-warning">En Reparación</span>`
          case 10:
            return `<span class="tag is-danger">Desechado</span>`
          case 11:
            return `<span class="tag is-danger">Obsequiado</span>`
          case 12:
            return `<span class="tag is-warning">Baja</span>`
        }
      },
      verHistoria (id) {
        this.$router.push({ path: `/Inventario/Historia/${id}` } )
      },
      selectNewOffice (result) {
        let id = Date.now()
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        console.log(result)
        const ubi = result.ubicacion ? result.ubicacion : this.itemCambiar.ubicacionArt
        const ofi = result.oficina ? result.oficina : this.itemCambiar.oficinaArt


        let idEntrega = ''
        let entrega = ''
        let idRecibe = ''
        let recibe = ''
        switch (result.estatus) {
          case 6:
            idEntrega = this.itemCambiar.idRecibe
            entrega = this.itemCambiar.recibe
            idRecibe = result.idUserAlmacen
            recibe = result.userAlmacen
            break
          case 7:
            idEntrega = this.itemCambiar.idRecibe
            entrega = this.itemCambiar.recibe
            idRecibe = this.itemCambiar.i_recibe
            recibe = this.itemCambiar.recibe
            break
          case 8:
            idEntrega = this.itemCambiar.idRecibe
            entrega = this.itemCambiar.recibe
            idRecibe = result.idUserAlmacen
            recibe = result.userAlmacen
            break
          case 9:
            idEntrega = this.itemCambiar.idRecibe
            entrega = this.itemCambiar.recibe
            idRecibe = result.idUserAlmacen
            recibe = result.userAlmacen
            break
          case 10:
            idEntrega = this.itemCambiar.idRecibe
            entrega = this.itemCambiar.recibe
            idRecibe = result.idUserAlmacen
            recibe = result.userAlmacen
            break
          case 11:
            idEntrega = '1538165924968'
            entrega = 'Administrador'
            idRecibe = this.itemCambiar.idRecibe
            recibe = this.itemCambiar.recibe
            break
        }
        
        InventarioServices.addUbicacion(id, this.itemCambiar.id_articulo, fechaReg, ubi, ofi, idEntrega, entrega, idRecibe, recibe, result.estatus)
          .then((data) => {
            let myObj = {
              success: data.success,
              respuesta: data.respuesta
            }
            this.$emit('updateUbicacion', myObj)
          })
          .catch((e) => {
            let myObj = {
              success: false,
              respuesta: e.message
            }
            this.$emit('updateUbicacion', myObj)
          })
      },
      cambiarUbicacion(item) {
        this.$emit('cambiarUbicacion', item)
      },
    },
    computed: {
      ...mapState(['userLogin'])
    },
    mounted() {
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
          this.modalStatus = false // how to hide any open modal?
        }
      })
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbOtrasAsignaciones.vue